import React, { useState, useEffect } from 'react'
import Loader from 'react-loader-spinner'
import classNames from 'classnames'

interface LoadingProps {
  size?: number
  className?: string
  color?: string
  type?:
    | 'Audio'
    | 'BallTriangle'
    | 'Bars'
    | 'Circles'
    | 'Grid'
    | 'Hearts'
    | 'Oval'
    | 'Puff'
    | 'Rings'
    | 'TailSpin'
    | 'ThreeDots'
    | 'Watch'
    | 'RevolvingDot'
    | 'Triangle'
    | 'Plane'
    | 'MutatingDots'
    | 'CradleLoader'
}

const Loading: React.FC<LoadingProps> = ({ size = 100, className, type = 'Oval', color = '#63b3ed' }) => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), 400)
    return () => clearTimeout(timer)
  }, [])

  return (
    <div className={classNames('flex justify-center items-center', className)}>
      {show && <Loader type={type} color={color} height={size} width={size} />}
    </div>
  )
}

export default Loading
